/**
 * Traducciones del feature de Caja ("Hacer la caja"). Viven en su propio módulo
 * (mismo patrón que reservationsNew) para no inflar translations.js. Se mergean
 * por idioma. Claves planas con prefijo `cashRegister.` + la card del dashboard.
 */
const cashRegister = {
  es: {
    // ── Rediseño 2026-07: el que cierra NO tipea lo que el sistema ya sabe ──
    // Nada de jerga contable: esto lo lee un encargado apurado a las 2 de la mañana.
    "cashRegister.today.eyebrow": "Cerrar el turno",
    "cashRegister.report.title": "CIERRE DE CAJA",
    "cashRegister.report.closedBy": "Cerró",
    "cashRegister.report.revenue": "RECAUDACIÓN",
    "cashRegister.report.cash": "EFECTIVO",
    "cashRegister.report.float": "Fondo",
    "cashRegister.report.counted": "Contado en el cajón",
    "cashRegister.report.out": "SALIÓ DEL CAJÓN",
    "cashRegister.report.ok": "Caja cuadrada",
    "cashRegister.report.note": "Nota",
    "cashRegister.report.tipsCashDrawer": "{m} en efectivo — apartalas del cajón",
    "cashRegister.report.openTables": "{n} mesa(s) quedaron SIN COBRAR",
    "cashRegister.report.noOpen": "Todas las mesas cobradas",
    "cashRegister.report.night": "La noche",
    "cashRegister.report.avgTicket": "ticket prom.",
    "cashRegister.report.perCover": "por cubierto",
    "cashRegister.report.tipsInDrawer": "en el cajón",
    "cashRegister.today.sub": "Contá la plata del cajón. Lo que se vendió ya lo sabe el sistema.",
    "cashRegister.today.pickDate": "Otro día",
    "cashRegister.today.backToday": "← Volver a hoy",
    "cashRegister.hero.label": "¿Cómo viene la caja?",
    "cashRegister.hero.count": "Contá el cajón",
    "cashRegister.hero.countCap": "Cuando pongas cuánto hay, te digo si cuadra.",
    "cashRegister.hero.ok": "Cuadra ✓",
    "cashRegister.hero.okCap": "La plata del cajón coincide con lo que se vendió.",
    "cashRegister.hero.missing": "FALTA esta plata en el cajón",
    "cashRegister.hero.over": "SOBRA esta plata en el cajón",
    "cashRegister.hero.noControl": "Efectivo del día. Sin comandas no hay con qué comparar.",
    "cashRegister.hero.blindCap": "Contá y declará todo. Cuando termines, revelás si cuadra.",
    "cashRegister.blind.note": "Cierre a ciegas: contá el cajón y declará los otros medios. Recién cuando termines te muestro si cuadra — así el número es genuino.",
    "cashRegister.blind.reveal": "Terminé de contar — revelar",
    "cashRegister.config.control": "Control",
    "cashRegister.config.blindClose": "Cierre a ciegas",
    "cashRegister.config.blindCloseHelp": "El que cierra cuenta la plata SIN ver cuánto debería haber. La diferencia se revela al final. Es el control anti-robo que usan los sistemas grandes: si alguien afanó, no puede acomodar el conteo de memoria.",
    "cashRegister.openTables": "Ojo: quedaron {n} mesa(s) sin cobrar",
    "cashRegister.openTablesGo": "Ver",
    "cashRegister.step.sales": "Lo que se vendió",
    "cashRegister.step.salesAuto": "Lo cargó el sistema solo. No tenés que tipear nada.",
    "cashRegister.step.salesManual": "Este local no usa comandas: cargalo a mano abajo.",
    "cashRegister.step.salesLoading": "Cargando lo que vendió el sistema…",
    "cashRegister.step.cash": "Contá lo que quedó en el cajón",
    "cashRegister.step.cashSub": "Toda la plata que hay ahora, fondo incluido (ya sin lo que sacaste).",
    "cashRegister.step.out": "Antes de contar: ¿sacás plata del cajón?",
    "cashRegister.step.outSub": "Pagale ahora al cadete, a los chicos, al proveedor… y anotalo acá. Lo que vayas a pagar después de contar, no lo anotes.",
    "cashRegister.step.check": "¿Cuadra?",
    "cashRegister.step.checkSub": "La cuenta del cajón y, abajo, los otros medios.",
    "cashRegister.step.checkManual": "Cargá lo que cobraste por cada medio.",
    "cashRegister.sys.total": "Vendido",
    "cashRegister.sys.inCash": "En efectivo",
    "cashRegister.drawer.title": "El cajón",
    "cashRegister.drawer.float": "Fondo con el que abriste",
    "cashRegister.drawer.sales": "Vendiste en efectivo",
    "cashRegister.drawer.out": "Sacaste del cajón",
    "cashRegister.drawer.should": "Tendría que haber",
    "cashRegister.drawer.counted": "Contaste",
    "cashRegister.drawer.ok": "Cuadra",
    "cashRegister.drawer.missing": "Faltan",
    "cashRegister.drawer.over": "Sobran",
    "cashRegister.before.q": "Sobra casi lo mismo que sacaste del cajón ({m}). ¿Contaste antes de pagar? Si esa plata todavía estaba en el cajón cuando contaste, se cuenta dos veces.",
    "cashRegister.before.fix": "Sí, conté antes de pagar: restar {m} de lo contado",
    "cashRegister.before.recount": "Si es así, volvé a contar el cajón ahora que ya pagaste.",
    "cashRegister.before.note": "Se contó antes de pagar {m}: se restó de lo contado",
    "cashRegister.methods.head": "Otros medios",
    "cashRegister.methods.hint": "¿Cuánto te llegó por cada medio? Fijate en el banco o el posnet y ponelo en cada uno.",
    "cashRegister.methods.sys": "Sistema",
    "cashRegister.methods.got": "Te llegó",
    "cashRegister.methods.diff": "Diferencia",
    "cashRegister.report.sold": "VENDIDO",
    "cashRegister.report.drawer": "EL CAJÓN",
    "cashRegister.report.salesCash": "Ventas en efectivo",
    "cashRegister.report.outTotal": "Sacado del cajón",
    "cashRegister.report.should": "Tendría que haber",
    "cashRegister.report.cashMade": "Hecho en efectivo",
    "cashRegister.report.beforeHint": "Sobra casi lo mismo que se sacó del cajón: ¿se contó antes de pagar?",
    "cashRegister.report.otherMethods": "OTROS MEDIOS",
    "cashRegister.sys.tables": "{n} mesa(s)",
    "cashRegister.sys.covers": "{n} cubierto(s)",
    "cashRegister.sys.tips": "Propinas",
    "cashRegister.sys.none": "El sistema no tiene ventas de este día.",
    "cashRegister.methods.extraTip": "¿Entró de más porque dejaron propina con el pago? Se anota al cobrar la mesa: en Propina, «Con el pago».",
    "cashRegister.tips.ask": "Sobra casi lo mismo que las propinas ({m}). ¿Las propinas quedan en el cajón?",
    "cashRegister.dlvFees.hint": "Falta casi lo mismo que los envíos cobrados en efectivo ({m}). Si el envío se lo queda el cadete, cargalo como gasto «Cadete» y el cierre cuadra.",
    "cashRegister.tips.yes": "Sí, sumalas",
    "cashRegister.tips.on": "Propinas en el cajón ({m}) — sumadas al esperado.",
    "cashRegister.tips.undo": "Deshacer",
    "cashRegister.today.float": "Fondo (el cambio con el que abriste)",
    "cashRegister.today.floatHint": "La plata que ya estaba antes de vender. No es venta.",
    "cashRegister.today.counted": "¿Cuánto hay en el cajón?",
    "cashRegister.today.notes": "Nota",
    "cashRegister.today.close": "Cerrar la caja",
    "cashRegister.today.share": "Mandar por WhatsApp",
    "cashRegister.today.saved": "Caja cerrada",
    "cashRegister.exp.gasto": "Gasto",
    "cashRegister.exp.retiro": "Retiro",
    "cashRegister.exp.gastoPh": "¿Qué pagaste? (hielo, delivery…)",
    "cashRegister.exp.retiroPh": "¿Quién se la llevó?",
    "cashRegister.exp.amount": "Monto",
    "cashRegister.exp.remove": "Borrar",
    "cashRegister.exp.addGasto": "Pagué algo",
    "cashRegister.exp.addRetiro": "Saqué plata",
    "cashRegister.final.handOver": "Guardás",
    "cashRegister.final.handOverCap": "La plata que te llevás del cajón.",
    "cashRegister.final.leave": "Dejás de fondo",
    "cashRegister.final.leaveCap": "El cambio para abrir mañana.",
    "cashRegister.final.noteWhy": "— contá qué pasó",
    "cashRegister.final.notePh": "Ej: faltó un vuelto de la mesa 4, lo trae mañana",
    "cashRegister.final.noteNudge": "No cuadra. Escribí en la nota qué pasó — mañana nadie se va a acordar. Igual podés cerrar.",
    // Card en el panel de la carta
    "menuDashboard.feature.cashRegister.title": "Hacer la caja",
    "menuDashboard.feature.cashRegister.desc":
      "Cerrá la caja del día en un minuto y guardá el historial, como el cuaderno pero sin perderlo.",
    "menuDashboard.feature.cashRegister.badge": "Nuevo",

    // Nav
    "cashRegister.nav.back": "Volver",
    "cashRegister.nav.today": "Hoy",
    "cashRegister.nav.history": "Historial",
    "cashRegister.nav.config": "Ajustes",

    // Medios de pago
    "cashRegister.method.efectivo": "Efectivo",
    "cashRegister.method.debito": "Débito",
    "cashRegister.method.credito": "Crédito",
    "cashRegister.method.mercadopago": "Mercado Pago",
    "cashRegister.method.modo": "MODO",
    "cashRegister.method.cuentadni": "Cuenta DNI",
    "cashRegister.method.transferencia": "Transferencia",
    "cashRegister.method.vales": "Vales / Ticket",
    "cashRegister.deferred.title": "Se cobra después",
    "cashRegister.deferred.sub": "Lo cobraron las apps de delivery. No está en la caja de hoy: te lo depositan más adelante.",
    "cashRegister.deferred.total": "Total por cobrar",
    "cashRegister.overdue.title": "Ya tendrían que haberte pagado",
    "cashRegister.overdue.since": "{n} pedidos · el más viejo hace {d} días",
    "cashRegister.overdue.hint": "Según el plazo que configuraste para cada app. Si ya te depositaron, marcalo en Comandas → Historial.",
    "cashRegister.deferred.sysline": "De eso, lo cobran las apps",
    "cashRegister.report.deferred": "Se cobra despues",
    "cashRegister.report.deferredNote": "no entra en la caja de hoy",

    // Turnos
    "cashRegister.turn.dia": "Mediodía",
    "cashRegister.turn.noche": "Noche",

    // Pantalla "Hacer la caja"
    "cashRegister.today.title": "Hacer la caja",
    "cashRegister.today.dateLabel": "Día de la caja",
    "cashRegister.today.floatLabel": "Fondo (el cambio)",
    "cashRegister.today.floatHelp": "La plata con la que abriste para dar vuelto.",
    "cashRegister.today.floatTip": "Podés dejar tu fondo fijo en Ajustes y viene solo.",
    "cashRegister.today.countLabel": "¿Cuánto efectivo contaste?",
    "cashRegister.today.countHelp": "Vaciá el cajón y poné el total que contaste.",
    "cashRegister.today.countDenomHelp":
      "Armá pilas por billete y poné cuántos hay de cada uno. Sumamos solos.",
    "cashRegister.today.coins": "Monedas",
    "cashRegister.today.cashOfDay": "Efectivo del día",
    "cashRegister.today.othersCard": "¿Cuánto entró por los otros medios?",
    "cashRegister.today.othersHelp": "Lo que leés del posnet y del celular.",
    "cashRegister.today.addMethod": "¿Cobraste por otro medio?",
    "cashRegister.today.expensesCard": "Gastos y retiros de la caja",
    "cashRegister.today.expensesHelp":
      "Solo lo que pagaste o sacaste EN EFECTIVO del cajón (proveedores en mano, tu retiro). Lo que pagaste por transferencia o tarjeta NO va acá.",
    "cashRegister.today.addExpense": "Agregar",
    "cashRegister.today.removeExpense": "Borrar",
    "cashRegister.today.expenseLabelPh": "¿En qué? (ej. flete verdulería)",
    "cashRegister.today.kindGasto": "Gasto",
    "cashRegister.today.kindRetiro": "Retiro",
    "cashRegister.today.controlCard": "¿Cuadra? (opcional)",
    "cashRegister.today.controlHelp":
      "¿Sabés cuánto vendiste en efectivo hoy? Poné ese total (de las comandas, el Z o tu cuenta) y te decimos si la caja cuadra o te falta plata.",
    "cashRegister.today.controlField": "Total que vendiste en efectivo",
    "cashRegister.today.notesLabel": "Nota (opcional)",
    "cashRegister.today.notesPh": "Ej: faltó 1.500, vuelto mal dado.",
    "cashRegister.today.totalRevenue": "Recaudación del día",
    "cashRegister.today.toHandOver": "Para guardar (sin el fondo)",
    "cashRegister.today.floatWord": "fondo",
    "cashRegister.today.expWord": "gastos/retiros",
    "cashRegister.today.closeBtn": "Cerrar caja",
    "cashRegister.today.saveBtn": "Guardar cambios",
    "cashRegister.today.saving": "Guardando…",
    "cashRegister.today.alreadyClosed":
      "Ya cerraste esta caja. Podés corregir y volver a guardar.",
    "cashRegister.today.confirmClose": "¿Guardar la caja?",
    "cashRegister.today.savedToast": "Caja guardada ✓",
    "cashRegister.today.saveError": "No se pudo guardar. Probá de nuevo.",
    "cashRegister.today.nothingToSave": "Cargá al menos un total antes de cerrar.",
    "cashRegister.today.shareBtn": "Compartir por WhatsApp",
    "cashRegister.today.legal": "Esto no reemplaza el cierre Z del controlador fiscal.",

    // Compartir
    "cashRegister.share.title": "Caja",

    // Chips de descuadre
    "cashRegister.chip.ok": "La caja cuadra ✓",
    "cashRegister.chip.short": "Faltan",
    "cashRegister.chip.over": "Sobran",
    "cashRegister.chip.noData": "Sin control",

    // Historial
    "cashRegister.history.title": "Historial",
    "cashRegister.history.monthTitle": "Este mes",
    "cashRegister.history.monthClosures": "cierres",
    "cashRegister.history.empty": "Todavía no cerraste ninguna caja.",
    "cashRegister.history.emptyCta": "Cerrá tu primera caja desde la pestaña Hoy.",
    "cashRegister.history.confirmDelete": "¿Borrar esta caja del historial?",
    "cashRegister.history.deleted": "Caja borrada",
    "cashRegister.history.delete": "Borrar",

    // Ajustes
    "cashRegister.config.title": "Ajustes de la caja",
    "cashRegister.config.defaultFloat": "Fondo fijo",
    "cashRegister.config.defaultFloatHelp":
      "El cambio con el que abrís todos los días. Viene pre-cargado al hacer la caja.",
    "cashRegister.config.methods": "¿Qué medios de pago usás?",
    "cashRegister.config.methodsHelp":
      "Solo aparecen los que marques, así la pantalla queda cortita.",
    "cashRegister.config.tolerance": "Diferencia que perdonás",
    "cashRegister.config.toleranceHelp":
      "Si la diferencia es menor a esto, la caja igual cuadra (verde).",
    "cashRegister.config.extras": "Extras",
    "cashRegister.config.turnos": "Separar mediodía y noche",
    "cashRegister.config.turnosHelp":
      "Hacés dos cajas por día, una por turno, para saber en cuál se descuadró.",
    "cashRegister.config.countDetail": "Contar los billetes por pila",
    "cashRegister.config.countDetailHelp":
      "En vez de un total, ponés cuántos billetes hay de cada uno y sumamos solos.",
    "cashRegister.config.advanced": "Funciones avanzadas",
    "cashRegister.config.advancedHelp":
      "Se van a conectar con tu menú y tus costos cuando esté el sistema de comandas.",
    "cashRegister.config.comingSoon": "Próximamente",
    "cashRegister.config.saved": "Guardado ✓",

    // Capas futuras (próximamente)
    "cashRegister.layer.salesMix": "Cargar qué se vendió",
    "cashRegister.layer.foodCostReal": "Food-cost real del día",
    "cashRegister.layer.covers": "Cubiertos y ticket promedio",
  },

  en: {
    "cashRegister.today.eyebrow": "Close the shift",
    "cashRegister.report.title": "CASH CLOSE",
    "cashRegister.report.closedBy": "Closed by",
    "cashRegister.report.revenue": "TOTAL TAKEN",
    "cashRegister.report.cash": "CASH",
    "cashRegister.report.float": "Float",
    "cashRegister.report.counted": "Counted in drawer",
    "cashRegister.report.out": "TAKEN FROM DRAWER",
    "cashRegister.report.ok": "Drawer balances",
    "cashRegister.report.note": "Note",
    "cashRegister.report.tipsCashDrawer": "{m} in cash — set aside from the drawer",
    "cashRegister.report.openTables": "{n} table(s) left UNCHARGED",
    "cashRegister.report.noOpen": "All tables charged",
    "cashRegister.report.night": "The night",
    "cashRegister.report.avgTicket": "avg. ticket",
    "cashRegister.report.perCover": "per cover",
    "cashRegister.report.tipsInDrawer": "in the drawer",
    "cashRegister.today.sub": "Count the cash in the drawer. The system already knows what was sold.",
    "cashRegister.today.pickDate": "Other day",
    "cashRegister.today.backToday": "← Back to today",
    "cashRegister.hero.label": "How's the register doing?",
    "cashRegister.hero.count": "Count the drawer",
    "cashRegister.hero.countCap": "Once you enter what's there, I'll tell you if it adds up.",
    "cashRegister.hero.ok": "It adds up ✓",
    "cashRegister.hero.okCap": "The cash in the drawer matches what was sold.",
    "cashRegister.hero.missing": "This much is MISSING from the drawer",
    "cashRegister.hero.over": "This much is EXTRA in the drawer",
    "cashRegister.hero.noControl": "Cash for the day. Without the POS there's nothing to compare against.",
    "cashRegister.hero.blindCap": "Count and declare everything. When you finish, you reveal whether it balances.",
    "cashRegister.blind.note": "Blind close: count the drawer and declare the other methods. Only when you finish do I show whether it balances — so the number is genuine.",
    "cashRegister.blind.reveal": "Done counting — reveal",
    "cashRegister.config.control": "Control",
    "cashRegister.config.blindClose": "Blind close",
    "cashRegister.config.blindCloseHelp": "Whoever closes counts the money WITHOUT seeing how much there should be. The difference is revealed at the end. It is the anti-theft control the big systems use: if someone skimmed, they can not adjust the count from memory.",
    "cashRegister.openTables": "Heads up: {n} table(s) were left uncharged",
    "cashRegister.openTablesGo": "View",
    "cashRegister.step.sales": "What was sold",
    "cashRegister.step.salesAuto": "The system loaded it. You don't have to type anything.",
    "cashRegister.step.salesManual": "This place doesn't use the POS: enter it by hand below.",
    "cashRegister.step.salesLoading": "Loading what the system sold…",
    "cashRegister.step.cash": "Count what's left in the drawer",
    "cashRegister.step.cashSub": "All the money there now, float included (without what you took out).",
    "cashRegister.step.out": "Before counting: taking money out of the drawer?",
    "cashRegister.step.outSub": "Pay the driver, the staff, the supplier… now, and note it here. Don't note what you'll pay after counting.",
    "cashRegister.step.check": "Does it add up?",
    "cashRegister.step.checkSub": "The drawer math and, below, the other methods.",
    "cashRegister.step.checkManual": "Enter what you took in for each method.",
    "cashRegister.sys.total": "Sold",
    "cashRegister.sys.inCash": "In cash",
    "cashRegister.drawer.title": "The drawer",
    "cashRegister.drawer.float": "Float you opened with",
    "cashRegister.drawer.sales": "Cash sales",
    "cashRegister.drawer.out": "Taken out of the drawer",
    "cashRegister.drawer.should": "Should be there",
    "cashRegister.drawer.counted": "You counted",
    "cashRegister.drawer.ok": "Balances",
    "cashRegister.drawer.missing": "Missing",
    "cashRegister.drawer.over": "Extra",
    "cashRegister.before.q": "The extra is almost what you took out ({m}). Did you count before paying? If that money was still in the drawer when you counted, it's counted twice.",
    "cashRegister.before.fix": "Yes, I counted before paying: subtract {m} from the count",
    "cashRegister.before.recount": "If so, count the drawer again now that you've paid.",
    "cashRegister.before.note": "Counted before paying {m}: subtracted from the count",
    "cashRegister.methods.head": "Other methods",
    "cashRegister.methods.hint": "How much came in by each method? Check the bank or card terminal and enter it.",
    "cashRegister.methods.sys": "System",
    "cashRegister.methods.got": "Received",
    "cashRegister.methods.diff": "Difference",
    "cashRegister.report.sold": "SOLD",
    "cashRegister.report.drawer": "THE DRAWER",
    "cashRegister.report.salesCash": "Cash sales",
    "cashRegister.report.outTotal": "Taken out",
    "cashRegister.report.should": "Should be there",
    "cashRegister.report.cashMade": "Made in cash",
    "cashRegister.report.beforeHint": "The extra is almost what was taken out: counted before paying?",
    "cashRegister.report.otherMethods": "OTHER METHODS",
    "cashRegister.sys.tables": "{n} table(s)",
    "cashRegister.sys.covers": "{n} cover(s)",
    "cashRegister.sys.tips": "Tips",
    "cashRegister.sys.none": "The system has no sales for this day.",
    "cashRegister.methods.extraTip": "Did extra money come in because someone tipped with the payment? You record it when charging the table: under Tip, «With the payment».",
    "cashRegister.tips.ask": "The extra is almost the same as tips ({m}). Do tips stay in the drawer?",
    "cashRegister.dlvFees.hint": "The shortage is almost the same as the delivery fees collected in cash ({m}). If the driver keeps the fee, log it as a “Driver” expense and the count will match.",
    "cashRegister.tips.yes": "Yes, add them",
    "cashRegister.tips.on": "Tips in the drawer ({m}) — added to expected.",
    "cashRegister.tips.undo": "Undo",
    "cashRegister.today.float": "Float (the change you opened with)",
    "cashRegister.today.floatHint": "The money that was there before selling. It's not a sale.",
    "cashRegister.today.counted": "How much is in the drawer?",
    "cashRegister.today.notes": "Note",
    "cashRegister.today.close": "Close the register",
    "cashRegister.today.share": "Send on WhatsApp",
    "cashRegister.today.saved": "Register closed",
    "cashRegister.exp.gasto": "Expense",
    "cashRegister.exp.retiro": "Withdrawal",
    "cashRegister.exp.gastoPh": "What did you pay for? (ice, delivery…)",
    "cashRegister.exp.retiroPh": "Who took it?",
    "cashRegister.exp.amount": "Amount",
    "cashRegister.exp.remove": "Delete",
    "cashRegister.exp.addGasto": "I paid for something",
    "cashRegister.exp.addRetiro": "I took money out",
    "cashRegister.final.handOver": "You keep",
    "cashRegister.final.handOverCap": "The money you take from the drawer.",
    "cashRegister.final.leave": "You leave as float",
    "cashRegister.final.leaveCap": "The change to open tomorrow.",
    "cashRegister.final.noteWhy": "— tell us what happened",
    "cashRegister.final.notePh": "E.g. table 4's change was short, they'll bring it tomorrow",
    "cashRegister.final.noteNudge":
      "It doesn't add up. Write what happened in the note — nobody will remember tomorrow. You can still close.",
    "menuDashboard.feature.cashRegister.title": "Cash close",
    "menuDashboard.feature.cashRegister.desc":
      "Close the day's register in a minute and keep the history — like the notebook but you never lose it.",
    "menuDashboard.feature.cashRegister.badge": "New",

    "cashRegister.nav.back": "Back",
    "cashRegister.nav.today": "Today",
    "cashRegister.nav.history": "History",
    "cashRegister.nav.config": "Settings",

    "cashRegister.method.efectivo": "Cash",
    "cashRegister.method.debito": "Debit",
    "cashRegister.method.credito": "Credit",
    "cashRegister.method.mercadopago": "Mercado Pago",
    "cashRegister.method.modo": "MODO",
    "cashRegister.method.cuentadni": "Cuenta DNI",
    "cashRegister.method.transferencia": "Transfer",
    "cashRegister.method.vales": "Vouchers",
    "cashRegister.deferred.title": "Paid out later",
    "cashRegister.deferred.sub": "Collected by the delivery apps. Not in today's till: they pay you out later.",
    "cashRegister.deferred.total": "Total owed",
    "cashRegister.overdue.title": "They should have paid you by now",
    "cashRegister.overdue.since": "{n} orders · oldest {d} days ago",
    "cashRegister.overdue.hint": "Based on the payout window you set for each app. If they already paid, mark it in Comandas → History.",
    "cashRegister.deferred.sysline": "Of that, collected by the apps",
    "cashRegister.report.deferred": "Paid out later",
    "cashRegister.report.deferredNote": "not part of today's till",

    "cashRegister.turn.dia": "Lunch",
    "cashRegister.turn.noche": "Dinner",

    "cashRegister.today.title": "Cash close",
    "cashRegister.today.dateLabel": "Register day",
    "cashRegister.today.floatLabel": "Float (the change)",
    "cashRegister.today.floatHelp": "The money you opened with to give change.",
    "cashRegister.today.floatTip": "You can set a fixed float in Settings so it's pre-filled.",
    "cashRegister.today.countLabel": "How much cash did you count?",
    "cashRegister.today.countHelp": "Empty the drawer and enter the total.",
    "cashRegister.today.countDenomHelp":
      "Stack bills by denomination and enter how many of each. We add it up.",
    "cashRegister.today.coins": "Coins",
    "cashRegister.today.cashOfDay": "Cash for the day",
    "cashRegister.today.othersCard": "How much came in via other methods?",
    "cashRegister.today.othersHelp": "What you read from the POS and your phone.",
    "cashRegister.today.addMethod": "Got paid another way?",
    "cashRegister.today.expensesCard": "Cash expenses and withdrawals",
    "cashRegister.today.expensesHelp":
      "Only what you paid or took IN CASH from the drawer (suppliers in cash, your withdrawal). What you paid by transfer or card does NOT go here.",
    "cashRegister.today.addExpense": "Add",
    "cashRegister.today.removeExpense": "Remove",
    "cashRegister.today.expenseLabelPh": "What for? (e.g. produce delivery)",
    "cashRegister.today.kindGasto": "Expense",
    "cashRegister.today.kindRetiro": "Withdrawal",
    "cashRegister.today.controlCard": "Does it balance? (optional)",
    "cashRegister.today.controlHelp":
      "Do you know how much cash you sold today? Enter that total (from tickets, the Z report or your own count) and we'll tell you if the register balances or you're short.",
    "cashRegister.today.controlField": "Cash sales total",
    "cashRegister.today.notesLabel": "Note (optional)",
    "cashRegister.today.notesPh": "e.g. short 1,500, wrong change given.",
    "cashRegister.today.totalRevenue": "Total for the day",
    "cashRegister.today.toHandOver": "To set aside (without the float)",
    "cashRegister.today.floatWord": "float",
    "cashRegister.today.expWord": "expenses/withdrawals",
    "cashRegister.today.closeBtn": "Close register",
    "cashRegister.today.saveBtn": "Save changes",
    "cashRegister.today.saving": "Saving…",
    "cashRegister.today.alreadyClosed":
      "You already closed this register. You can fix it and save again.",
    "cashRegister.today.confirmClose": "Save the register?",
    "cashRegister.today.savedToast": "Register saved ✓",
    "cashRegister.today.saveError": "Couldn't save. Try again.",
    "cashRegister.today.nothingToSave": "Enter at least one total before closing.",
    "cashRegister.today.shareBtn": "Share on WhatsApp",
    "cashRegister.today.legal": "This does not replace the fiscal Z report.",

    "cashRegister.share.title": "Register",

    "cashRegister.chip.ok": "It balances ✓",
    "cashRegister.chip.short": "Short",
    "cashRegister.chip.over": "Over",
    "cashRegister.chip.noData": "No check",

    "cashRegister.history.title": "History",
    "cashRegister.history.monthTitle": "This month",
    "cashRegister.history.monthClosures": "closes",
    "cashRegister.history.empty": "You haven't closed any register yet.",
    "cashRegister.history.emptyCta": "Close your first register from the Today tab.",
    "cashRegister.history.confirmDelete": "Delete this register from history?",
    "cashRegister.history.deleted": "Register deleted",
    "cashRegister.history.delete": "Delete",

    "cashRegister.config.title": "Register settings",
    "cashRegister.config.defaultFloat": "Fixed float",
    "cashRegister.config.defaultFloatHelp":
      "The change you open with every day. Pre-filled when you close the register.",
    "cashRegister.config.methods": "Which payment methods do you use?",
    "cashRegister.config.methodsHelp":
      "Only the ones you pick show up, keeping the screen short.",
    "cashRegister.config.tolerance": "Difference you allow",
    "cashRegister.config.toleranceHelp":
      "If the difference is smaller than this, it still balances (green).",
    "cashRegister.config.extras": "Extras",
    "cashRegister.config.turnos": "Split lunch and dinner",
    "cashRegister.config.turnosHelp":
      "Two closes per day, one per shift, so you know which one was off.",
    "cashRegister.config.countDetail": "Count bills by stack",
    "cashRegister.config.countDetailHelp":
      "Instead of a total, enter how many bills of each and we add it up.",
    "cashRegister.config.advanced": "Advanced features",
    "cashRegister.config.advancedHelp":
      "They'll connect with your menu and costs once the kitchen-order system is ready.",
    "cashRegister.config.comingSoon": "Coming soon",
    "cashRegister.config.saved": "Saved ✓",

    "cashRegister.layer.salesMix": "Log what was sold",
    "cashRegister.layer.foodCostReal": "Real food-cost of the day",
    "cashRegister.layer.covers": "Covers and average ticket",
  },

  pt: {
    "cashRegister.today.eyebrow": "Fechar o turno",
    "cashRegister.report.title": "FECHAMENTO DE CAIXA",
    "cashRegister.report.closedBy": "Fechado por",
    "cashRegister.report.revenue": "ARRECADAÇÃO",
    "cashRegister.report.cash": "DINHEIRO",
    "cashRegister.report.float": "Troco inicial",
    "cashRegister.report.counted": "Contado na gaveta",
    "cashRegister.report.out": "SAIU DA GAVETA",
    "cashRegister.report.ok": "Caixa fecha",
    "cashRegister.report.note": "Observação",
    "cashRegister.report.tipsCashDrawer": "{m} em dinheiro — separe da gaveta",
    "cashRegister.report.openTables": "{n} mesa(s) ficaram SEM COBRAR",
    "cashRegister.report.noOpen": "Todas as mesas cobradas",
    "cashRegister.report.night": "A noite",
    "cashRegister.report.avgTicket": "ticket méd.",
    "cashRegister.report.perCover": "por pessoa",
    "cashRegister.report.tipsInDrawer": "na gaveta",
    "cashRegister.today.sub": "Conte o dinheiro da gaveta. O que foi vendido o sistema já sabe.",
    "cashRegister.today.pickDate": "Outro dia",
    "cashRegister.today.backToday": "← Voltar para hoje",
    "cashRegister.hero.label": "Como está o caixa?",
    "cashRegister.hero.count": "Conte a gaveta",
    "cashRegister.hero.countCap": "Quando você colocar quanto tem, eu digo se fecha.",
    "cashRegister.hero.ok": "Fecha ✓",
    "cashRegister.hero.okCap": "O dinheiro da gaveta bate com o que foi vendido.",
    "cashRegister.hero.missing": "FALTA este dinheiro na gaveta",
    "cashRegister.hero.over": "SOBRA este dinheiro na gaveta",
    "cashRegister.hero.noControl": "Dinheiro do dia. Sem o PDV não há com o que comparar.",
    "cashRegister.hero.blindCap": "Conte e declare tudo. Quando terminar, você revela se fecha.",
    "cashRegister.blind.note": "Fechamento cego: conte a gaveta e declare os outros meios. Só quando terminar eu mostro se fecha — assim o número é genuíno.",
    "cashRegister.blind.reveal": "Terminei de contar — revelar",
    "cashRegister.config.control": "Controle",
    "cashRegister.config.blindClose": "Fechamento cego",
    "cashRegister.config.blindCloseHelp": "Quem fecha conta o dinheiro SEM ver quanto deveria ter. A diferença é revelada no final. É o controle antifraude que os sistemas grandes usam: se alguém desviou, não pode ajustar a contagem de memória.",
    "cashRegister.openTables": "Atenção: {n} mesa(s) ficaram sem cobrar",
    "cashRegister.openTablesGo": "Ver",
    "cashRegister.step.sales": "O que foi vendido",
    "cashRegister.step.salesAuto": "O sistema carregou sozinho. Você não precisa digitar nada.",
    "cashRegister.step.salesManual": "Este local não usa o PDV: carregue à mão abaixo.",
    "cashRegister.step.salesLoading": "Carregando o que o sistema vendeu…",
    "cashRegister.step.cash": "Conte o que ficou na gaveta",
    "cashRegister.step.cashSub": "Todo o dinheiro que tem agora, fundo incluído (já sem o que você tirou).",
    "cashRegister.step.out": "Antes de contar: vai tirar dinheiro da gaveta?",
    "cashRegister.step.outSub": "Pague agora o entregador, a equipe, o fornecedor… e anote aqui. O que for pagar depois de contar, não anote.",
    "cashRegister.step.check": "Fecha?",
    "cashRegister.step.checkSub": "A conta da gaveta e, abaixo, os outros meios.",
    "cashRegister.step.checkManual": "Carregue o que recebeu por cada meio.",
    "cashRegister.sys.total": "Vendido",
    "cashRegister.sys.inCash": "Em dinheiro",
    "cashRegister.drawer.title": "A gaveta",
    "cashRegister.drawer.float": "Fundo com que abriu",
    "cashRegister.drawer.sales": "Vendas em dinheiro",
    "cashRegister.drawer.out": "Tirado da gaveta",
    "cashRegister.drawer.should": "Deveria ter",
    "cashRegister.drawer.counted": "Você contou",
    "cashRegister.drawer.ok": "Fecha",
    "cashRegister.drawer.missing": "Faltam",
    "cashRegister.drawer.over": "Sobram",
    "cashRegister.before.q": "Sobra quase o mesmo que você tirou da gaveta ({m}). Contou antes de pagar? Se esse dinheiro ainda estava na gaveta quando contou, ele é contado duas vezes.",
    "cashRegister.before.fix": "Sim, contei antes de pagar: descontar {m} do contado",
    "cashRegister.before.recount": "Se for isso, conte a gaveta de novo agora que já pagou.",
    "cashRegister.before.note": "Contou antes de pagar {m}: descontado do contado",
    "cashRegister.methods.head": "Outros meios",
    "cashRegister.methods.hint": "Quanto entrou por cada meio? Confira no banco ou na maquininha e coloque em cada um.",
    "cashRegister.methods.sys": "Sistema",
    "cashRegister.methods.got": "Recebido",
    "cashRegister.methods.diff": "Diferença",
    "cashRegister.report.sold": "VENDIDO",
    "cashRegister.report.drawer": "A GAVETA",
    "cashRegister.report.salesCash": "Vendas em dinheiro",
    "cashRegister.report.outTotal": "Tirado da gaveta",
    "cashRegister.report.should": "Deveria ter",
    "cashRegister.report.cashMade": "Feito em dinheiro",
    "cashRegister.report.beforeHint": "Sobra quase o mesmo que saiu da gaveta: contou antes de pagar?",
    "cashRegister.report.otherMethods": "OUTROS MEIOS",
    "cashRegister.sys.tables": "{n} mesa(s)",
    "cashRegister.sys.covers": "{n} pessoa(s)",
    "cashRegister.sys.tips": "Gorjetas",
    "cashRegister.sys.none": "O sistema não tem vendas deste dia.",
    "cashRegister.methods.extraTip": "Entrou dinheiro a mais porque deixaram gorjeta junto com o pagamento? Anota-se ao cobrar a mesa: em Gorjeta, «Com o pagamento».",
    "cashRegister.tips.ask": "Sobra quase o mesmo que as gorjetas ({m}). As gorjetas ficam na gaveta?",
    "cashRegister.dlvFees.hint": "Falta quase o mesmo que as taxas de entrega recebidas em dinheiro ({m}). Se a taxa fica com o entregador, lance como despesa “Entregador” e o fechamento bate.",
    "cashRegister.tips.yes": "Sim, some",
    "cashRegister.tips.on": "Gorjetas na gaveta ({m}) — somadas ao esperado.",
    "cashRegister.tips.undo": "Desfazer",
    "cashRegister.today.float": "Troco inicial (com o que você abriu)",
    "cashRegister.today.floatHint": "O dinheiro que já estava antes de vender. Não é venda.",
    "cashRegister.today.counted": "Quanto tem na gaveta?",
    "cashRegister.today.notes": "Observação",
    "cashRegister.today.close": "Fechar o caixa",
    "cashRegister.today.share": "Enviar por WhatsApp",
    "cashRegister.today.saved": "Caixa fechado",
    "cashRegister.exp.gasto": "Despesa",
    "cashRegister.exp.retiro": "Retirada",
    "cashRegister.exp.gastoPh": "O que você pagou? (gelo, delivery…)",
    "cashRegister.exp.retiroPh": "Quem levou?",
    "cashRegister.exp.amount": "Valor",
    "cashRegister.exp.remove": "Excluir",
    "cashRegister.exp.addGasto": "Paguei algo",
    "cashRegister.exp.addRetiro": "Tirei dinheiro",
    "cashRegister.final.handOver": "Você guarda",
    "cashRegister.final.handOverCap": "O dinheiro que você leva da gaveta.",
    "cashRegister.final.leave": "Deixa de troco",
    "cashRegister.final.leaveCap": "O troco para abrir amanhã.",
    "cashRegister.final.noteWhy": "— conte o que aconteceu",
    "cashRegister.final.notePh": "Ex: faltou o troco da mesa 4, traz amanhã",
    "cashRegister.final.noteNudge":
      "Não fecha. Escreva na observação o que aconteceu — amanhã ninguém vai lembrar. Você pode fechar mesmo assim.",
    "menuDashboard.feature.cashRegister.title": "Fechar o caixa",
    "menuDashboard.feature.cashRegister.desc":
      "Feche o caixa do dia em um minuto e guarde o histórico — como o caderno, mas sem perder.",
    "menuDashboard.feature.cashRegister.badge": "Novo",

    "cashRegister.nav.back": "Voltar",
    "cashRegister.nav.today": "Hoje",
    "cashRegister.nav.history": "Histórico",
    "cashRegister.nav.config": "Ajustes",

    "cashRegister.method.efectivo": "Dinheiro",
    "cashRegister.method.debito": "Débito",
    "cashRegister.method.credito": "Crédito",
    "cashRegister.method.mercadopago": "Mercado Pago",
    "cashRegister.method.modo": "MODO",
    "cashRegister.method.cuentadni": "Cuenta DNI",
    "cashRegister.method.transferencia": "Transferência",
    "cashRegister.method.vales": "Vales / Ticket",
    "cashRegister.deferred.title": "Recebe depois",
    "cashRegister.deferred.sub": "Cobrado pelos apps de delivery. Não está no caixa de hoje: te repassam mais adiante.",
    "cashRegister.deferred.total": "Total a receber",
    "cashRegister.overdue.title": "Já deveriam ter te pago",
    "cashRegister.overdue.since": "{n} pedidos · o mais antigo há {d} dias",
    "cashRegister.overdue.hint": "Conforme o prazo que você configurou para cada app. Se já te repassaram, marque em Comandas → Histórico.",
    "cashRegister.deferred.sysline": "Disso, cobram os apps",
    "cashRegister.report.deferred": "Recebe depois",
    "cashRegister.report.deferredNote": "nao entra no caixa de hoje",

    "cashRegister.turn.dia": "Almoço",
    "cashRegister.turn.noche": "Jantar",

    "cashRegister.today.title": "Fechar o caixa",
    "cashRegister.today.dateLabel": "Dia do caixa",
    "cashRegister.today.floatLabel": "Fundo (o troco)",
    "cashRegister.today.floatHelp": "O dinheiro com que abriu para dar troco.",
    "cashRegister.today.floatTip": "Você pode deixar seu fundo fixo nos Ajustes e vem sozinho.",
    "cashRegister.today.countLabel": "Quanto dinheiro você contou?",
    "cashRegister.today.countHelp": "Esvazie a gaveta e coloque o total.",
    "cashRegister.today.countDenomHelp":
      "Faça pilhas por nota e coloque quantas há de cada uma. Somamos sozinhos.",
    "cashRegister.today.coins": "Moedas",
    "cashRegister.today.cashOfDay": "Dinheiro do dia",
    "cashRegister.today.othersCard": "Quanto entrou pelos outros meios?",
    "cashRegister.today.othersHelp": "O que você lê da maquininha e do celular.",
    "cashRegister.today.addMethod": "Recebeu por outro meio?",
    "cashRegister.today.expensesCard": "Gastos e retiradas do caixa",
    "cashRegister.today.expensesHelp":
      "Só o que você pagou ou tirou EM DINHEIRO da gaveta (fornecedores em mãos, sua retirada). O que pagou por transferência ou cartão NÃO vai aqui.",
    "cashRegister.today.addExpense": "Adicionar",
    "cashRegister.today.removeExpense": "Excluir",
    "cashRegister.today.expenseLabelPh": "Para quê? (ex. frete do sacolão)",
    "cashRegister.today.kindGasto": "Gasto",
    "cashRegister.today.kindRetiro": "Retirada",
    "cashRegister.today.controlCard": "Bate? (opcional)",
    "cashRegister.today.controlHelp":
      "Você sabe quanto vendeu em dinheiro hoje? Coloque esse total (das comandas, do Z ou da sua conta) e dizemos se o caixa bate ou está faltando.",
    "cashRegister.today.controlField": "Total vendido em dinheiro",
    "cashRegister.today.notesLabel": "Observação (opcional)",
    "cashRegister.today.notesPh": "Ex: faltaram 1.500, troco errado.",
    "cashRegister.today.totalRevenue": "Faturamento do dia",
    "cashRegister.today.toHandOver": "Para guardar (sem o fundo)",
    "cashRegister.today.floatWord": "fundo",
    "cashRegister.today.expWord": "gastos/retiradas",
    "cashRegister.today.closeBtn": "Fechar caixa",
    "cashRegister.today.saveBtn": "Salvar alterações",
    "cashRegister.today.saving": "Salvando…",
    "cashRegister.today.alreadyClosed":
      "Você já fechou este caixa. Pode corrigir e salvar de novo.",
    "cashRegister.today.confirmClose": "Salvar o caixa?",
    "cashRegister.today.savedToast": "Caixa salvo ✓",
    "cashRegister.today.saveError": "Não foi possível salvar. Tente de novo.",
    "cashRegister.today.nothingToSave": "Coloque ao menos um total antes de fechar.",
    "cashRegister.today.shareBtn": "Compartilhar no WhatsApp",
    "cashRegister.today.legal": "Isto não substitui a Redução Z do fiscal.",

    "cashRegister.share.title": "Caixa",

    "cashRegister.chip.ok": "O caixa bate ✓",
    "cashRegister.chip.short": "Faltam",
    "cashRegister.chip.over": "Sobram",
    "cashRegister.chip.noData": "Sem controle",

    "cashRegister.history.title": "Histórico",
    "cashRegister.history.monthTitle": "Este mês",
    "cashRegister.history.monthClosures": "fechamentos",
    "cashRegister.history.empty": "Você ainda não fechou nenhum caixa.",
    "cashRegister.history.emptyCta": "Feche seu primeiro caixa na aba Hoje.",
    "cashRegister.history.confirmDelete": "Excluir este caixa do histórico?",
    "cashRegister.history.deleted": "Caixa excluído",
    "cashRegister.history.delete": "Excluir",

    "cashRegister.config.title": "Ajustes do caixa",
    "cashRegister.config.defaultFloat": "Fundo fixo",
    "cashRegister.config.defaultFloatHelp":
      "O troco com que abre todos os dias. Vem pré-preenchido ao fechar o caixa.",
    "cashRegister.config.methods": "Quais meios de pagamento você usa?",
    "cashRegister.config.methodsHelp":
      "Só aparecem os que você marcar, deixando a tela curta.",
    "cashRegister.config.tolerance": "Diferença que você perdoa",
    "cashRegister.config.toleranceHelp":
      "Se a diferença for menor que isto, o caixa bate mesmo assim (verde).",
    "cashRegister.config.extras": "Extras",
    "cashRegister.config.turnos": "Separar almoço e jantar",
    "cashRegister.config.turnosHelp":
      "Dois fechamentos por dia, um por turno, para saber em qual desbalanceou.",
    "cashRegister.config.countDetail": "Contar as notas por pilha",
    "cashRegister.config.countDetailHelp":
      "Em vez de um total, você coloca quantas notas de cada e somamos sozinhos.",
    "cashRegister.config.advanced": "Funções avançadas",
    "cashRegister.config.advancedHelp":
      "Vão se conectar com seu menu e seus custos quando o sistema de comandas estiver pronto.",
    "cashRegister.config.comingSoon": "Em breve",
    "cashRegister.config.saved": "Salvo ✓",

    "cashRegister.layer.salesMix": "Registrar o que foi vendido",
    "cashRegister.layer.foodCostReal": "Food-cost real do dia",
    "cashRegister.layer.covers": "Talheres e ticket médio",
  },
};

export default cashRegister;
